import { render, staticRenderFns } from "./AddonsItem.vue?vue&type=template&id=c14a86d2&"
import script from "./AddonsItem.vue?vue&type=script&lang=js&"
export * from "./AddonsItem.vue?vue&type=script&lang=js&"
import style0 from "./AddonsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports